let canvasTools = ['paintBrush', 'rectangle', 'circle', 'eraser', 'textMarker'];
let canvasToolSizes = [3, 5, 9, 15, 20, 27, 36];
let canvasToolColors = [
  '#000000',
  '#7f7f7f',
  '#880015',
  '#ed1c24',
  '#ff7f27',
  '#fff200',
  '#22b14c',
  '#00a2e8',
  '#3f48cc',
  '#a349a4',
  '#ffffff',
  '#c3c3c3',
  '#b97a57',
  '#ffaec9',
  '#ffc90e',
  '#efe4b0',
  '#b5e61d',
  '#99d9ea',
  '#7092be',
  '#c8bfe7',
];

const state = {
  myCanvas: {},
  tempCanvas: {},
  textMarkerCanvas: {},
  canvasHeight: 0,
  canvasWidth: 0,
  canvasTop: 0,
  canvasLeft: 0,
  backupCanvasHeight: 0,
  backupCanvasWidth: 0,
  backupCanvasTop: 0,
  backupCanvasLeft: 0,
  canvasActive: false,
  textMarkerCanvasActive: false,
  textMarkerCanvasOpacity: 0.4,
  showCanvasToolbox: false,
  allTools: canvasTools,
  tool: canvasTools[0],
  allSizes: canvasToolSizes,
  toolSize: canvasToolSizes[2],
  allCollors: canvasToolColors,
  toolColor: canvasToolColors[0],
};

const mutations = {
  MY_CANVAS(state, canvas) {
    state.myCanvas = canvas;
  },
  TEXT_MARKER_CANVAS(state, canvas) {
    state.textMarkerCanvas = canvas;
  },
  TEMP_CANVAS(state, canvas) {
    state.tempCanvas = canvas;
  },
  CHANGE_CANVAS_HEIGHT(state, height) {
    state.canvasHeight = height;
  },
  CHANGE_CANVAS_WIDTH(state, width) {
    state.canvasWidth = width;
  },
  CHANGE_CANVAS_TOP(state, top) {
    state.canvasTop = top;
  },
  CHANGE_CANVAS_LEFT(state, left) {
    state.canvasLeft = left;
  },
  CHANGE_BACKUP_CANVAS_HEIGHT(state, height) {
    state.backupCanvasHeight = height;
  },
  CHANGE_BACKUP_CANVAS_WIDTH(state, width) {
    state.backupCanvasWidth = width;
  },
  CHANGE_BACKUP_CANVAS_TOP(state, top) {
    state.backupCanvasTop = top;
  },
  CHANGE_BACKUP_CANVAS_LEFT(state, left) {
    state.backupCanvasLeft = left;
  },
  TOGGLE_CANVAS(state) {
    state.canvasActive = !state.canvasActive;
  },

  TOGGLE_CANVAS_TOOLBOX(state) {
    state.showCanvasToolbox = !state.showCanvasToolbox;
  },
  TOGGLE_CANVAS_TEXT_MARKER(state, textMarkerCanvasActive) {
    state.textMarkerCanvasActive = textMarkerCanvasActive;
  },
  CHANGE_CANVA_STOOL_SIZE(state, size) {
    state.toolSize = size;
  },
  CHANGE_CANVAS_TOOL_COLOR(state, color) {
    state.toolColor = color;
  },
  CHANGE_CANVAS_TOOLL(state, tool) {
    state.tool = tool;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER');
  },
};

const getters = {
  allTools: (state) => {
    return state.allTools;
  },
  allSizes: (state) => {
    return state.allSizes;
  },
  allCollors: (state) => {
    return state.allCollors;
  },

  myCanvas: (state) => {
    return state.myCanvas;
  },
  textMarkerCanvas: (state) => {
    return state.textMarkerCanvas;
  },
  tempCanvas: (state) => {
    return state.tempCanvas;
  },
  canvasWidth: (state) => {
    return state.canvasWidth;
  },
  canvasHeight: (state) => {
    return state.canvasHeight;
  },
  canvasTop: (state) => {
    return state.canvasTop;
  },
  canvasLeft: (state) => {
    return state.canvasLeft;
  },
  backupCanvasWidth: (state) => {
    return state.backupCanvasWidth;
  },
  backupCanvasHeight: (state) => {
    return state.backupCanvasHeight;
  },
  backupCanvasTop: (state) => {
    return state.backupCanvasTop;
  },
  backupCanvasLeft: (state) => {
    return state.backupCanvasLeft;
  },
  canvasActive: (state) => {
    return state.canvasActive;
  },
  tool: (state) => {
    return state.tool;
  },
  toolSize: (state) => {
    return state.toolSize;
  },
  toolColor: (state) => {
    return state.toolColor;
  },
  showCanvasToolbox: (state) => {
    return state.showCanvasToolbox;
  },
  textMarkerCanvasActive: (state) => {
    return state.textMarkerCanvasActive;
  },
  textMarkerCanvasOpacity: (state) => {
    return state.textMarkerCanvasOpacity;
  },
  canvasActive: (state) => {
    return state.canvasActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
